import "./Footer.css";

export default function Footer() {

  return (
    <footer className="footer">

      <p>
        Sistema de Transparência © {new Date().getFullYear()}
      </p>

      <span>
        Desenvolvido por Percept
      </span>

    </footer>
  );

}